export default class BlockChart {
	constructor() {
		this.galleries = document.querySelectorAll('.block-chart');

		if (this.galleries.length > 0) {
			this.galleries.forEach((gallery) => {
				let masonryGrid = gallery.querySelector('.block-chart-grid-masonry');

				// 1. Vérification de la présence de la grille et des bibliothèques
				if (masonryGrid) {
					if (typeof Masonry !== "function") {
						console.warn("Masonry n'est pas chargé");
						return;
					}

					// 2. On attend que les images soient prêtes avant de lancer Masonry
					// Note : 'imagesLoaded' est disponible globalement via WordPress
					imagesLoaded(masonryGrid, () => {
						new Masonry(masonryGrid, {
							percentPosition: true,
							transitionDuration: 0
						});
					});
				}
			});
		}
	}
}